// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Is9Wi","newExpiryDate":"styles_newExpiryDate__1Txm5","footer":"styles_footer__22kgI"};